import React from 'react';
import FormAuthAzure from './FormAuthAzure';

const authComponents = {
  azure: { component: FormAuthAzure },
};

const FormAuth = ({
  disabled,
  error,
  field,
  onChange,
}) => {
  let AuthComponent = authComponents[field.authProvider];
  if (!AuthComponent) {
    AuthComponent = authComponents.azure;
  }

  const Component = AuthComponent.component;
  return (
    <Component
      field={field}
      disabled={disabled}
      onChange={onChange}
      error={error}
    />
  );
};

export default FormAuth;
